<template>
     <transition name="overlay">
        <div class="overlay" v-if="visible">
            <div class="overlay-content">
                <img src="img/popup.jpg" />
                <div>
                    <h2>{{ title }}</h2>
                    <slot></slot>
                </div>
                <button class="button button-primary" type="button" @click="close">{{ $t("common.ok") }}</button>
                <span class="close icon-cross" @click="close"></span>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    methods: {
        close() {
            this.$emit('close');
        }
    },
    props: {
        title: {
            type: String
        },
        visible: { default: false,
            type: Boolean
        }
    }
})
</script>